/**
 * C&C Start Next Person Button
 *
 * Adds a "Start Next Person" button to product pages.
 * Clicking it reloads the current product page so the personalization
 * fields return to their default/blank state.
 *
 * Shopify cart contents remain saved.
 */

(function () {
  'use strict';

  var BUTTON_ID = 'cc-start-next-person-btn';

  function createButton() {
    var wrapper = document.createElement('div');
    wrapper.id = 'cc-start-next-person-wrapper';

    wrapper.style.cssText = [
      'margin-top: 12px',
      'display: flex',
      'flex-direction: column',
      'align-items: flex-start',
      'gap: 6px'
    ].join(';');

    var button = document.createElement('button');
    button.id = BUTTON_ID;
    button.type = 'button';
    button.textContent = 'Start Next Person';

    button.style.cssText = [
      'background: transparent',
      'border: 1px solid currentColor',
      'color: inherit',
      'padding: 10px 20px',
      'font-size: 0.875rem',
      'font-family: inherit',
      'font-weight: 600',
      'letter-spacing: 0.05em',
      'text-transform: uppercase',
      'cursor: pointer',
      'opacity: 0.75',
      'transition: opacity 0.2s ease',
      'border-radius: 3px'
    ].join(';');

    button.addEventListener('mouseenter', function () {
      button.style.opacity = '1';
    });

    button.addEventListener('mouseleave', function () {
      button.style.opacity = '0.75';
    });

    button.addEventListener('click', function () {
      window.location.reload();
    });

    var helper = document.createElement('p');

    helper.textContent =
      'Already added this person to your cart? Start the next person to enter new personalization information.';

    helper.style.cssText = [
      'margin: 0',
      'font-size: 0.75rem',
      'opacity: 0.6',
      'font-family: inherit',
      'line-height: 1.4'
    ].join(';');

    wrapper.appendChild(button);
    wrapper.appendChild(helper);

    return wrapper;
  }

  function injectButton(productFormComponent) {
    if (document.getElementById(BUTTON_ID)) {
      return;
    }

    var wrapper = createButton();

    var addToCartContainer =
      productFormComponent.querySelector('add-to-cart-component');

    if (addToCartContainer && addToCartContainer.parentNode) {
      addToCartContainer.parentNode.insertBefore(
        wrapper,
        addToCartContainer.nextSibling
      );

      return;
    }

    if (productFormComponent.parentNode) {
      productFormComponent.parentNode.insertBefore(
        wrapper,
        productFormComponent.nextSibling
      );
    }
  }

  function init() {
    function tryInject() {
      var productFormComponent =
        document.querySelector('product-form-component');

      if (productFormComponent) {
        injectButton(productFormComponent);
        return true;
      }

      return false;
    }

    if (tryInject()) {
      return;
    }

    var observer = new MutationObserver(function () {
      if (tryInject()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
